import React, { useEffect, useState } from "react";
import Card from "components/card";
import { getSettings, saveSettings } from "services/settings";
import { useToast } from "components/Toast";

const AdminSettings: React.FC = () => {
  const [siteName, setSiteName] = useState("");
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getSettings();
        setSiteName(data.siteName || "");
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await saveSettings({ siteName });
      toast.showSuccess("Settings saved");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to save settings");
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Settings</h2>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <form onSubmit={handleSave} className="max-w-md space-y-4">
          <div>
            <label className="block text-sm">Site Name</label>
            <input
              value={siteName}
              onChange={(e) => setSiteName(e.target.value)}
              className="input w-full"
            />
          </div>
          <div>
            <button className="rounded bg-indigo-600 px-4 py-2 text-white">
              Save
            </button>
          </div>
        </form>
      )}
    </Card>
  );
};

export default AdminSettings;
